import Button from "../ui/button";

const DashboardActions = ({ onGenerarInforme }) => (
  <div className="flex justify-end space-x-4">
    <Button 
      variant="outline" 
      className="bg-white border-indigo-500 text-indigo-600 hover:bg-indigo-50 hover:border-indigo-700 hover:text-indigo-700 shadow-sm transition-all duration-300"
      onClick={onGenerarInforme} // Ahora onGenerarInforme está definido
    >
      Generar Informe
    </Button>
    <Button className="bg-gradient-to-r from-indigo-600 to-indigo-800 text-white shadow-md hover:from-indigo-700 hover:to-indigo-900 hover:shadow-lg transition-all duration-300 transform hover:-translate-y-0.5">
      Ver Detalles Completos
    </Button>
  </div>
);

export default DashboardActions;